import { Button, Row, Col, Divider } from 'antd';
import { GoogleOutlined, FacebookOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './Login.css';

interface SocialLoginProps {
  onSocialLogin: (accessToken: string) => void;
  baseUrl: string;
}

enum SocialProvider {
  googleLoginUrl = 'googleLoginUrl',
  facebookLoginUrl = 'facebookLoginUrl'
}

const SocialLogin: React.FC<SocialLoginProps> = ({ onSocialLogin, baseUrl }) => {
  const { t } = useTranslation();

  const getSocialLoginUrl = (provider: SocialProvider): string => {
    switch (provider) {
      case SocialProvider.googleLoginUrl:
        return "/accounts/google/login/";
      case SocialProvider.facebookLoginUrl:
        return "/accounts/facebook/login/";
      default:
        return "";
    }
  };

  const handleSocialLogin = (provider: SocialProvider) => {
    // Store current URL to return to after social login
    const currentUrl = window.location.href;
    localStorage.setItem('social_login_return_url', currentUrl);
    
    // Use absolute URL to ensure it replaces any existing base URL
    const loginUrl = "https://prod.goodmates.org" + getSocialLoginUrl(provider);

    // Redirect to social login URL in the same page
    window.location.href = loginUrl;
  };

  return (
    <div className="social-login-container">
      <Divider>
        <span className="divider-text">{t('login.orContinueWith')}</span>
      </Divider>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Button
            className="social-login-button google-button"
            icon={<GoogleOutlined />}
            onClick={() => handleSocialLogin(SocialProvider.googleLoginUrl)}
            block
            size="large"
          >
            Google
          </Button>
        </Col>
        <Col span={12}>
          <Button
            className="social-login-button facebook-button"
            icon={<FacebookOutlined />}
            onClick={() => handleSocialLogin(SocialProvider.facebookLoginUrl)}
            block
            size="large"
          >
            Facebook
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SocialLogin;